
import { VCard } from "vuetify/lib";

export default VCard.extend({});
